import * as React from "react";
import ClosestStoreComponent from "../components/ClosestStoreComponent";
import FormComponent from "../components/FormComponent";
import ModalSubHeaderComponent from "../components/ModalSubHeaderComponent";
import { isMobileOnly } from 'react-device-detect';
import { getStores, getStoreStock } from "../api-helper";
import { checkProductIncludeColours, setAnalyticsStoreinfo } from '../common-utils'
import { getColorConfig } from '../config-helper';
import { raiseGAEvent, GA_EVENTS } from '../analytics';

export class FindInStoreResultsPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showMoreStores: false, closestStoresArray: [],
      selectedColor: '', showEdit: false, stockByStores: {},
      isLoading: true, selectedColourId: '', noStoresErrorMessage: ''
    };
  }

  componentDidMount() {
    this.setClosestStoresAndStocks();
  }

  componentDidUpdate = () =>{
    const { sizes, selectedSizes, selectedColourId, changeSizes } = this.props;

    if (sizes && sizes.length > 0 && selectedSizes.length > 0){
      const isLoading = sizes.find(el => el.product_id === selectedSizes[0].product_id);
      if(!isLoading){
        changeSizes(selectedColourId);
      }
    }
  }

  getSelectedProductIds(selectedSizes, selectedAccessories) {
    let selectedProductIds = [];
    if (selectedSizes && selectedSizes.length > 0) {
      selectedProductIds = selectedProductIds.concat(selectedSizes.map((i) => i.product_sku));
    }
    if (selectedAccessories && selectedAccessories.length > 0) {
      selectedProductIds = selectedProductIds.concat(selectedAccessories.map((i) => i.product_sku));
    }

    return selectedProductIds;
  }

  setClosestStoresAndStocks = async () => {
    const { initialDOMState, postCode, selectedSizes, selectedAccessories, productOutOfStockBuffer, productLowStockBuffer, simpleProductInfo, selectedColourId } = this.props;
    const { stockCheckApiEndpoint, stockCheckApiKey, isGrouped } = initialDOMState;

    this.setState({ isLoading: true });

    try {
      const closestStores = await getStores(postCode);

      if (closestStores.length === 0 ) {
        const msg = `No stores near ${(jQuery.isNumeric(postCode))? 'postcode': 'suburb' } ${postCode}.`;
        this.setState({isLoading: false, noStoresErrorMessage: msg});
      }

      let products = [];

      if (isGrouped) {
        if (selectedSizes.length > 0) {
          products = this.getSelectedProductIds(selectedSizes, selectedAccessories);
        }
        else {
          products = products.concat(JSON.parse(initialDOMState.groupedProductData)[selectedColourId].items.items[0].product_sku);
        }
      }
      else {
        products = [simpleProductInfo.sku];
      }

      const stockByStores = await getStoreStock(closestStores, products, productOutOfStockBuffer, productLowStockBuffer, stockCheckApiEndpoint, stockCheckApiKey);
      this.setState({ closestStoresArray: closestStores, stockByStores, isLoading: false });
    }
    catch (error) {
      this.setState({isLoading: false, noStoresErrorMessage: error});
    }
  }

  fetchStoreStock = async (selectedSizes, selectedAccessories) => {
    const { initialDOMState, productOutOfStockBuffer, productLowStockBuffer } = this.props;
    const { stockCheckApiEndpoint, stockCheckApiKey } = initialDOMState;
    const { closestStoresArray } = this.state;

    this.setState({ isLoading: true });
    const products = this.getSelectedProductIds(selectedSizes, selectedAccessories);
    const stockByStores = await getStoreStock(closestStoresArray, products, productOutOfStockBuffer, productLowStockBuffer, stockCheckApiEndpoint, stockCheckApiKey);
    this.setState({ stockByStores, isLoading: false });
  }

  handleShowEdit = () => {
    // google analytics event for edit selection
    raiseGAEvent(GA_EVENTS.CLICK_EDIT_SELECTION, '');

    this.setState({ showEdit: true , noStoresErrorMessage: ''});
    const { updateUserSelection, postCode, selectedColor, selectedSizes,
            selectedAccessories, selectedColourId } = this.props;
    updateUserSelection(postCode, selectedColor, selectedSizes, selectedAccessories, selectedColourId);
  }

  handleShowSearch = (postcode, selectedColor, selectedSizes, selectedAccessories, selectedColourId) => {
    const {initialDOMState } = this.props;
    const { isGrouped } = initialDOMState;
    this.setState({
      showEdit: false,
      postcode,
      selectedColor,
      selectedSizes,
      selectedAccessories,
      selectedColourId
    }, () => {
      if(!isGrouped || (isGrouped && selectedSizes.length === 0)){
        this.setClosestStoresAndStocks();
      }
    });

    this.fetchStoreStock(selectedSizes, selectedAccessories).then(() => {
      this.props.updateUserSelection(postcode, selectedColor, selectedSizes, selectedAccessories, selectedColourId);
      this.setClosestStoresAndStocks();
    });

    if(!isGrouped || (isGrouped && selectedSizes.length === 0)){
      this.props.updateUserSelection(postcode, selectedColor, selectedSizes, selectedAccessories, selectedColourId);
    }
  }

  pushGa4Event = (search) => {
    const { selectedSizes, selectedColourId, selectedColor } = this.props;

    window.dataLayer.push({
      event: 'find_in_store',
      ecommerce: {
        selectedSizes,
        selectedColor,
        selectedColourId,
        postcode: search,
      }
    });
  }

  renderClosestStores = () => {
    const { closestStoresArray, stockByStores, isLoading } = this.state;

    if (closestStoresArray.length > 0) {
      const closestStoreId = closestStoresArray[0].rms_store_code;
      const closestStoreStock = stockByStores[closestStoreId];
      const { sizes, accessories, simpleProductInfo, initialDOMState, postCode } = this.props;
      const { isGrouped } = initialDOMState;
      let products;
      if (isGrouped) {
        products = [...sizes, ...accessories];
      }
      else {
        products = [{
          product_sku: simpleProductInfo.sku,
          product_item_list_desc: simpleProductInfo.name
        }]
      }

      this.pushGa4Event(postCode);

      if (closestStoreStock) {
        if (!isLoading) { // Stocks loaded.
        {
          setAnalyticsStoreinfo(closestStoresArray, stockByStores);
        }
          return (
            <div>
              <ClosestStoreComponent products={products} inStock={closestStoreStock.inStock}
                lowStock={closestStoreStock.lowStock} outOfStock={closestStoreStock.noStock}
                data={closestStoresArray[0]}/>
              <br />
              <h3 className="bbnt-topic_sub-title">Other Stores Near You</h3>
              <div>
                {closestStoresArray.slice(1).map((store, index) => {
                  const storeStock = stockByStores[store.rms_store_code];
                  if (storeStock) {
                    return (
                      <ClosestStoreComponent key={index} products={products} inStock={storeStock.inStock}
                        lowStock={storeStock.lowStock} outOfStock={storeStock.noStock} data={store}/>
                    );
                  }
                })}
              </div>
            </div>
          );
        }
      }
    }

    return null;
  }

  renderStoreInformation = () => {
    const { isLoading, noStoresErrorMessage } = this.state;

    return (
      <div className="pure-u-1 pure-u-md-1-2 pure-u-sm-1 pure-u-lg-1-2 closest-store-component section-2">
        <br />
        <h3 className="bbnt-topic_sub-title">Your Closest Store</h3>
        {isLoading && <div>Loading...</div>}
        {noStoresErrorMessage !== '' && <div>{noStoresErrorMessage}</div>}
        {noStoresErrorMessage === '' && this.renderClosestStores()}
      </div>
    );
  }

  renderSelectedColor = () => {
    const { initialDOMState, selectedColor } = this.props;
    const { superGroup, isGrouped} = initialDOMState;
    const colours = getColorConfig(initialDOMState);

    if (colours
        && (Object.keys(colours).length > 0)
        && isGrouped
        && checkProductIncludeColours(superGroup)) {

     return (
      <div>
        <div className="section">
          <label>Colour</label> <span>{selectedColor}</span>
        </div>
        <hr />
      </div>
      );
    }
    return null;
  }

  renderSelectedAccessories(accessories) {
    if (accessories && accessories.length > 0) {
      const labels = accessories.map(i => i.product_item_list_desc).join(', ');
      return (
        <div>
          <div className="section">
            <label>Pillowcases</label>
            <span>{labels}</span>
          </div>
          <hr />
        </div>
      );
    }

    return null;
  }

  renderSelectedSizes(sizes) {
    if (sizes && sizes.length > 0) {
      const labels = sizes.map(i => i.product_item_list_desc).join(', ');
      return (
        <div>
          <div className="section">
            <label>Sizes</label>
            <span>{labels}</span>
          </div>
          <hr />
        </div>
      );
    }

    return null;
  }

  renderFormDetails = () => {
    const { showEdit } = this.state;
    const {
      postCode, selectedColor, selectedSizes, selectedAccessories,
      initialDOMState, selectedColourId, accessories, sizes
    } = this.props;

    if (!showEdit) {
      return (
        <div className="pure-g-r form-section">
          {isMobileOnly &&
            <div>
              <br />
              <div className="bbnt-topic_multipart">
                <div className="bbnt-topic_sub-title">You have selected:</div>
                <div className="bbnt-topic_button-wrap">
                  <button className="button button--state-edit bbnt-topic_button" onClick={this.handleShowEdit}>
                    EDIT
                  </button>
                </div>
              </div>
              <hr />
            </div>
          }
          {this.renderSelectedColor()}
          {this.renderSelectedSizes(selectedSizes)}
          {this.renderSelectedAccessories(selectedAccessories)}

          <div className="section">
            <label>Postcode or Suburb</label>
            <span>{postCode}</span>
          </div>
          <hr />
          {!isMobileOnly &&
            <div className="section">
              <button className="button button--state-edit" onClick={this.handleShowEdit}>
                EDIT SELECTION
            </button>
            </div>
          }
        </div>
      );
    }
    else {
      return (
        <div className="pure-g-r form-section">
          <FormComponent
            initialDOMState={initialDOMState}
            handleShowSearch={this.handleShowSearch}
            selectedColor={selectedColor}
            selectedSizes={selectedSizes}
            selectedAccessories={selectedAccessories}
            postCode={postCode}
            selectedColourId={selectedColourId}
            sizes={sizes}
            accessories={accessories}
          />
        </div>
      );
    }
  }

  render() {
    const { productName } = this.props.initialDOMState;

    return (
      <div className="find-in-store-form">
        <ModalSubHeaderComponent productName={productName}/>

        <div className="pure-g center result-sections">
          <div className="pure-u-1 pure-u-md-1-2 pure-u-sm-1 pure-u-lg-1-2 closest-store-component">
            {!isMobileOnly &&
              <div>
                <br />
                <h3 className="bbnt-topic_sub-title">Your Selection</h3>
                <hr />
              </div>
            }
            {this.renderFormDetails()}
          </div>
          {!this.state.showEdit && isMobileOnly && this.renderStoreInformation()}
          {!isMobileOnly && this.renderStoreInformation()}
        </div>
      </div>
    );
  }
}

FindInStoreResultsPage.propTypes = {
};

export default FindInStoreResultsPage;
